module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_9005.1220b5ba.png";